// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1QELw","title":"Images90_title__21XeO","images":"Images90_images__2iWuS"};